import {Unit} from './common.model';
import * as moment from 'moment';
import {EmployeeTimesheetAggregation} from './timesheet.model';
import {TranslateService} from '@ngx-translate/core';
import {SessionService} from "../services/session.service";
import {UnitManager} from "./UnitManager";
import {EmployeeHoraire} from "./EmployeHoraire";
import {TreeItem, TreeviewItem} from "../common/components/tree/models/treeview-item";
import {EmployeeExpenseAggregation} from "../home/expenses/model/EmployeeExpenseAggregation";
import {Expense} from "../home/expenses/model/Expense";

export class RootTimesheetItem<T extends TreeItem> implements TreeItem {
  text: string;
  value: any;
  disabled = false;
  checked = false;
  collapsed = false;

  // unit: Unit;
  children: PeriodTimesheetItem<T>[];
  constructor () {
    this.text = 'Root-TS';
  }

  add( child: PeriodTimesheetItem<T>) {
    if (!this.children) {
      this.children = [];
    }
    this.children.push(child);
  }
  // children: PeriodTimesheetItem[];
/*    add( child: Unit): UnitTreeItem {
      if (child) {
        if (!this._childrenByCode.get(child.unitCode)) {
          const unitTreeItem  = new UnitTreeItem(child);
          this._childrenByCode.set(child.unitCode, unitTreeItem);
          if (!this.children) {
            this.children = [];
          }
          this.children.push(unitTreeItem);
          this._sortChildren();
        }
        return this._childrenByCode.get(child.unitCode);
      }
      return null;
    }
  */
}

export class PeriodTimesheetItem<T extends TreeItem> implements TreeItem {
  text = 'PeridoTimesheetItem';
  value: any;
  // children: TimesheetTreeItem[];
  children: T[];
  constructor ( start: Date, end: Date, translate: TranslateService ) {
    this.text = translate.instant('WeekOf') + moment(start).format('LL') + ' - ' + moment(end).format('LL');
    // const startOfW = this.session.userInfo.startOfWeek(moment().add(nbWeeks, 'day').toDate());
    // const endOfW = this.session.userInfo.endOfWeek(moment().add(nbWeeks, 'day').toDate());
    //
    // const dateKeyInRange = tsManager.keysInDateRange(startOfW, endOfW);
    // if ( dateKeyInRange.length > 0 ) {
    //   // Add the week.
    //   const weekViewItem = new TreeviewItem({text: 'Semaine du ' + moment(startOfW).format('LL') + ' - ' + moment(startOfW).format('LL'), value: 1111 });
  }
  /*
  get text() {
    return this._text;
  }
   */

  add( child: T) {
    if (!this.children) {
      this.children = [];
    }
    this.children.push(child);
  }

}

export class TimesheetBeanForTree{
  employeeId: string;
  timesheets = new Array<EmployeeHoraire>();
}



export class TimesheetTreeItem implements TreeItem {
  _text = 'TimesheetTreeItem';
  // value: any;
  /** Contains all (including the TS approved for the whole period of time asked by the dashboard.) */
  data: EmployeeTimesheetAggregation;
  // others = new Array<EmployeeTimesheetAggregation>();
  /** Will contain only the Horaire for the week*/
  // value = {employeeId: '', ts: new Array<EmployeeHoraire>() };
  value: TimesheetBeanForTree;
  constructor( bean: EmployeeTimesheetAggregation) {
    this.data = bean; // Not really important.
    this.value = new TimesheetBeanForTree();
    this.value.employeeId = bean.employe.id;
  }
  /*
  constructor( bean: EmployeeTimesheetAggregation) {
    this.data = bean; // Not really important.
    this.value.push(bean);
  }
  */


  get text(){
    if (this.data) {
      if (this.data.employe) {
        let res = this.data.employe.fullName;
        if (this.value.timesheets ) {
          res += ' (' + (this.value.timesheets.length) + ')';
        }
        return res;
      }
    }
    return this._text;
  }

  // public add (bean: EmployeeTimesheetAggregation) {
  //   this.value.push(bean);
  // }
  public add (bean: EmployeeHoraire[]) {
    // console.log('Adding: ' + bean.length + ' horaires, for ' + this.data.employe.fullName);
    for (const eh of bean){
      // console.log('Adding ' + eh.refDate + ' for employee: ' + eh.employeeId  + ' id: ' + eh.id);
    }
    this.value.timesheets.push(...bean);
  }


}


export class ExpenseBeanForTree{
  employeeId: string;
  expenses = new Array<Expense>();
}

export class ExpenseTreeItem implements TreeItem {
  _text = 'ExpenseTreeItem';
  // value: any;
  /** Contains all (including the TS approved for the whole period of time asked by the dashboard.) */
  data: EmployeeExpenseAggregation;
  // others = new Array<EmployeeTimesheetAggregation>();
  /** Will contain only the Horaire for the week*/
    // value = {employeeId: '', ts: new Array<EmployeeHoraire>() };
  value: ExpenseBeanForTree;
  constructor( bean: EmployeeExpenseAggregation) {
    this.data = bean; // Not really important.
    this.value = new ExpenseBeanForTree();
    this.value.employeeId = bean.employeeId;
  }
  /*
  constructor( bean: EmployeeTimesheetAggregation) {
    this.data = bean; // Not really important.
    this.value.push(bean);
  }
  */


  get text(){
    if (this.data) {
      if (this.data.employeeLastName && this.data.employeeFirstName) {
        // let res = this.data.employeeFirstName+' ' + this.data.employeeLastName;
        let res = this.data.employeeLastName+' ' + this.data.employeeFirstName;
        if (this.value.expenses) {
          res += ' (' + (this.value.expenses.length) + ')';
        }
        return res;
      }
    }
    return this._text;
  }

  // public add (bean: EmployeeTimesheetAggregation) {
  //   this.value.push(bean);
  // }
  public add (bean: Expense[]) {
    // console.log('Adding: ' + bean.length + ' horaires, for ' + this.data.employe.fullName);
    // for (const eh of bean){
    //   // console.log('Adding ' + eh.refDate + ' for employee: ' + eh.employeeId  + ' id: ' + eh.id);
    // }
    this.value.expenses.push(...bean);
  }


}

export class UnitTreeItem implements TreeItem {
  text: string;
  value: any;
  unit: Unit;
  disabled = false;
  checked = false;
  collapsed = false;

  children: UnitTreeItem[];

  private _childrenByCode = new Map<string, UnitTreeItem>();

  constructor (unit: Unit,collapsed = false) {
    if (unit) {
      this.text = unit.description;
      this.value = unit.unitCode;
      this.unit = unit;
      this.collapsed = collapsed;
    }
  }

  find(toFind: Unit,checked=true,collapse=false):UnitTreeItem|null{
    if (this.unit && this.unit.unitCode===toFind.unitCode){
      // console.log('Unit found ',this.unit);
      this.checked = checked;
      this.collapsed = collapse;
      return this;
    }else if (this.children) {
      let res = null;
      for (const child of this.children){
        // console.log('Checking child ',child);
        res = child.find(toFind,checked,collapse);
        if (res){
          return res;
        }
      }
    }else{
      // console.log('No Children');
    }
    return null;
  }


  add( child: Unit, collapsed=false): UnitTreeItem {
    if (child) {
      if (!this._childrenByCode.get(child.unitCode)) {
          const unitTreeItem  = new UnitTreeItem(child,collapsed);
          this._childrenByCode.set(child.unitCode, unitTreeItem);
          if (!this.children) {
            this.children = [];
          }
          this.children.push(unitTreeItem);
          this._sortChildren();
      }
      return this._childrenByCode.get(child.unitCode);
    }
    return null;
  }


  private _sortChildren() {
    if (this.children) {
      this.children.sort(
        (a: UnitTreeItem, b: UnitTreeItem) => {
          let resN = 0;
          if (a.text > b.text) {
            resN = 1;
          }
          if (a.text < b.text) {
            resN = -1;
          }
          return resN;
        });
     }
  }

  debug(level: number) {
    let pad = '';
    for (let id = 0; id < level; id++) {
      pad += ' ';
    }
    if (this.unit) {
      console.log(pad + this.text + ' - ' + this.unit.type + ' (' +  this.value + ', parent: '  + this.unit.parentCode + ')');
    }else{
      console.log(pad + this.text +  (this.value + ''));
    }
    if (this.children) {
      for (const c of this.children ) {
        c.debug(level + 4);
      }
    }
  }



}

export class TreeHelper{

  public static loadTree(divisions: Unit[], session: SessionService,collapseService=false):UnitTreeItem {
    return this.loadTreeWithUnitManager(divisions,session.unitManager,session.hasMoreThanOneDivision(),collapseService);
  }


  public static loadTreeWithUnitManager(divisions: Unit[], unitManager: UnitManager, collapseDivision=false, collapseService=false):UnitTreeItem {
    const root = new UnitTreeItem(null);
    root.text = 'Divisions';

    for (const division of divisions){
      // console.log('division working on ' + division.unitCode + ' ' + division.description);
      const divisionTreeItem = root.add(division,collapseDivision);
      const services: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(division.unitCode, 'SERVICE');
      // console.log('Nb Services found: ' + services.length);
      for (const service of services){
        // console.log('service working on ' + service.unitCode + ' ' + service.description + ' ' + service.parentCode);
        const serviceTreeItem = divisionTreeItem.add(service,collapseService);
        const departments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(service.unitCode, 'DEPARTEMENT');
        // console.log('Nb Departments found: ' + services.length);
        for (const department of departments){
          // console.log('department working on ' + department.unitCode + ' ' + department.description + ' ' + department.parentCode);
          const departmentTreeItem = serviceTreeItem.add(department);
          const subDepartments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(department.unitCode, 'SOUS_DEPARTEMENT');
          // console.log('Nb SubDepartments found: ' + services.length);
          for (const subDepartment of subDepartments){
            // console.log('subDepartment working on ' + subDepartment.unitCode + ' ' + subDepartment.description + ' ' + subDepartment.parentCode);
            const subDepartmentTreeItem = departmentTreeItem.add(subDepartment);
          }
        }
      }
    }
    return root;

  }




  public static loadTreeNoRoot(divisions: Unit[], session: SessionService):TreeviewItem[] {
    return this.loadTreeNoRootWithUnitManager(divisions,session.unitManager,session.hasMoreThanOneDivision());
  }


  public static loadTreeNoRootWithUnitManager(divisions: Unit[], unitManager: UnitManager, collapseDivision=false):TreeviewItem[] {
    const res = new Array<TreeviewItem>();
    for (const division of divisions){
       // console.log('division working on ' + division.unitCode + ' ' + division.description + ' collapseDivision: ' + collapseDivision);

      const divisionTreeItem = new UnitTreeItem(division,collapseDivision);
      const services: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(division.unitCode, 'SERVICE');
       // console.log('Nb Services found: ' + services.length);
      for (const service of services){
         // console.log('service working on ' + service.unitCode + ' ' + service.description + ' ' + service.parentCode);
        const serviceTreeItem = divisionTreeItem.add(service);
        const departments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(service.unitCode, 'DEPARTEMENT');
        // console.log('Nb Departments found: ' + services.length);
        for (const department of departments){
          // console.log('department working on ' + department.unitCode + ' ' + department.description + ' ' + department.parentCode);
          const departmentTreeItem = serviceTreeItem.add(department);
          const subDepartments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(department.unitCode, 'SOUS_DEPARTEMENT');
          // console.log('Nb SubDepartments found: ' + services.length);
          for (const subDepartment of subDepartments){
            // console.log('subDepartment working on ' + subDepartment.unitCode + ' ' + subDepartment.description + ' ' + subDepartment.parentCode);
            const subDepartmentTreeItem = departmentTreeItem.add(subDepartment);
          }
        }
      }
      res.push(new TreeviewItem(divisionTreeItem));
    }
    return res;

  }



  private static found(toFind: string, poolToSearch: string[]):boolean{
    for (const b of poolToSearch){
      if (b === toFind){
        return true;
      }
    }
    return false;
  }

  public static loadTreeWithSelectedIds(divisions: Unit[], session: SessionService,...selectedUnitIds: string[]):UnitTreeItem {
    return this.loadTreeWithSelectedIdsWithUnitManager(divisions,session.unitManager,...selectedUnitIds);
  }


  public static loadTreeWithSelectedIdsWithUnitManager(divisions: Unit[], unitManager: UnitManager,...selectedUnitIds: string[]):UnitTreeItem {
    const root = new UnitTreeItem(null);
    root.text = 'Divisions';

    // console.log('SelectedUnitsIds: ',selectedUnitIds);

    let divisionSelected = false;
    // let selected = false;
    for (const division of divisions){
      // console.log('division working on ' + division.unitCode + ' ' + division.description);
      divisionSelected = this.found(division.unitCode,selectedUnitIds);
      const divisionTreeItem = root.add(division);
      divisionTreeItem.checked = divisionSelected;

      const services: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(division.unitCode, 'SERVICE');
      // console.log('Nb Services found: ' + services.length);
      for (const service of services){
        let serviceSelected = divisionSelected;
        // console.log('service working on ' + service.unitCode + ' ' + service.description + ' ' + service.parentCode);
        const serviceTreeItem = divisionTreeItem.add(service);
        if (!serviceSelected){
          serviceSelected = this.found(service.unitCode,selectedUnitIds);
        }
        serviceTreeItem.checked = serviceSelected;
        const departments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(service.unitCode, 'DEPARTEMENT');
        // console.log('Nb Departments found: ' + services.length);
        for (const department of departments){
          let departmentSelected = serviceSelected;
          // console.log('department working on ' + department.unitCode + ' ' + department.description + ' ' + department.parentCode);
          const departmentTreeItem = serviceTreeItem.add(department);
          if (!departmentSelected){
            departmentSelected = this.found(department.unitCode,selectedUnitIds);
          }
          departmentTreeItem.checked = departmentSelected;

          const subDepartments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(department.unitCode, 'SOUS_DEPARTEMENT');
          // console.log('Nb SubDepartments found: ' + services.length);
          for (const subDepartment of subDepartments){
            let subDepartmentSelected = departmentSelected;
            // console.log('subDepartment working on ' + subDepartment.unitCode + ' ' + subDepartment.description + ' ' + subDepartment.parentCode);
            const subDepartmentTreeItem = departmentTreeItem.add(subDepartment);
            if (!subDepartmentSelected){
              subDepartmentSelected = this.found(subDepartment.unitCode,selectedUnitIds);
            }
            subDepartmentTreeItem.checked = subDepartmentSelected;
            if (subDepartmentSelected){
              // console.log('Selected');
            }
          }
        }
      }
    }
    return root;

  }



  public static loadTreeNoRootWithSelectedIds(divisions: Unit[], session: SessionService,...selectedUnitIds: string[]):TreeviewItem[] {
    return this.loadTreeNoRootWithSelectedIdsWithUnitManager(divisions,session.unitManager,session.hasMoreThanOneDivision(),...selectedUnitIds);
  }
  public static loadTreeNoRootWithSelectedIdsWithUnitManager(divisions: Unit[], unitManager: UnitManager, collapseDivision=false,...selectedUnitIds: string[]):TreeviewItem[] {
    const res = new Array<TreeviewItem>();
    let divisionSelected = false;
    for (const division of divisions){
      // console.log('division working on ' + division.unitCode + ' ' + division.description + ' collapseDivision: ' + collapseDivision);

      const divisionTreeItem = new UnitTreeItem(division,collapseDivision);
      divisionSelected = this.found(division.unitCode,selectedUnitIds);
      divisionTreeItem.checked = divisionSelected;

      const services: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(division.unitCode, 'SERVICE');
      // console.log('Nb Services found: ' + services.length);
      for (const service of services){
        // console.log('service working on ' + service.unitCode + ' ' + service.description + ' ' + service.parentCode);
        let serviceSelected = divisionSelected;

        const serviceTreeItem = divisionTreeItem.add(service);
        if (!serviceSelected){
          serviceSelected = this.found(service.unitCode,selectedUnitIds);
        }
        serviceTreeItem.checked = serviceSelected;

        if (serviceSelected){
          divisionTreeItem.collapsed = false;
        }


        const departments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(service.unitCode, 'DEPARTEMENT');
        // console.log('Nb Departments found: ' + services.length);
        for (const department of departments){

          let departmentSelected = serviceSelected;

          // console.log('department working on ' + department.unitCode + ' ' + department.description + ' ' + department.parentCode);
          const departmentTreeItem = serviceTreeItem.add(department);
          if (!departmentSelected){
            departmentSelected = this.found(department.unitCode,selectedUnitIds);
          }
          departmentTreeItem.checked = departmentSelected;
          if (departmentSelected){
            divisionTreeItem.collapsed = false;
          }

          const subDepartments: Unit[] = unitManager.getOrderedUnitByParentCodeAndType(department.unitCode, 'SOUS_DEPARTEMENT');
          // console.log('Nb SubDepartments found: ' + services.length);
          for (const subDepartment of subDepartments){

            let subDepartmentSelected = departmentSelected;
            // console.log('subDepartment working on ' + subDepartment.unitCode + ' ' + subDepartment.description + ' ' + subDepartment.parentCode);
            const subDepartmentTreeItem = departmentTreeItem.add(subDepartment);
            if (!subDepartmentSelected){
              subDepartmentSelected = this.found(subDepartment.unitCode,selectedUnitIds);
            }
            subDepartmentTreeItem.checked = subDepartmentSelected;
            if (subDepartmentSelected){
              divisionTreeItem.collapsed = false;
              // console.log('Selected');
            }
          }
        }
      }
      res.push(new TreeviewItem(divisionTreeItem));
    }
    return res;

  }


}







